import { render } from "./OvApplicationCard.vue?vue&type=template&id=2320a719&scoped=true"
import script from "./OvApplicationCard.vue?vue&type=script&lang=js"
export * from "./OvApplicationCard.vue?vue&type=script&lang=js"

import "./OvApplicationCard.vue?vue&type=style&index=0&id=2320a719&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2320a719"],['__file',"src/components/OvApplicationCard.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2320a719"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2320a719', __exports__)) {
    api.reload('2320a719', __exports__)
  }
  
  module.hot.accept("./OvApplicationCard.vue?vue&type=template&id=2320a719&scoped=true", () => {
    api.rerender('2320a719', render)
  })

}


export default __exports__